"use strict";

jQuery(document).ready(function ($) {
  if ($('.mb-block_logo-details').length) {
    // Get the road-builders members modal block 
    var modalBlock = document.querySelectorAll('.mb-block_logo-details');
    if ('IntersectionObserver' in window) {
      var handleIntersectionModalBlock = function handleIntersectionModalBlock(entries) {
        entries.map(function (entry) {
          if (entry.isIntersecting) {
            // console.log(entry);

            //move modal to bottom of document for z-indexing issues
            $("#logo-details-modal").appendTo('body');
            $(document).on("click", "body .open-modal.mb-block_logo-details__logo-col", function () {
              $("#logo-details-modal").modal({
                show: true
              });
              $('body').addClass('no-scroll');
              $('body').addClass('road-builders-block');
              console.log('Click');
            });
            $("#logo-details-modal").click(function (event) {
              if (event.target.id == "logo-details-modal") {
                $('.modal').modal('hide');
                $('body').removeClass('modal-open');
                $('.modal-backdrop').remove();
                if ($('body').hasClass('no-scroll')) {
                  $('body').removeClass('no-scroll');
                }
              }
            });
            $('a.road-builders-close[data-dismiss="modal"]').click(function (event) {
              if ($('body').hasClass('no-scroll')) {
                $('body').removeClass('no-scroll');
                $('body').removeClass('road-builders-block');
              }
            });
            observer.unobserve(entry.target);
          } else {
            // console.log('entry is NOT Intersecting');
          }
        });
      };
      var observer = new IntersectionObserver(handleIntersectionModalBlock);
      modalBlock.forEach(function (modalBlock) {
        return observer.observe(modalBlock);
      });
    } else {
      console.log('Please use a modern browser');
      // <Fallback Logic Here>
    }
  }
});